import { Button } from '../../cdl/Button/Button';
import { useDrawer } from '../../cdl/Drawer/useDrawer.hook';
import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { IconPlus } from '../../common/icons/cdl/Plus';
import { Page } from '../../common/Page/Page';
import { PageGrid } from '../../common/PageGrid';
import { Box } from '../../common/ui/Box';

import { CreateCustomerGroup } from './components/CreateCustomerGroup';
import { CustomerGroupSearch } from './components/CustomerGroupSearch';
import { CustomerGroupsTable } from './components/CustomerGroupsTable';

export const CustomerGroupsOverviewPage = () => {
    useDocumentTitle(translate('page.customergroupoverview'));
    const { push, pop } = useDrawer();

    return (
        <Page>
            <PageGrid>
                <Box display="flex" justifyContent="space-between" alignItems="center" gap={16}>
                    <Text variant="headline" as="h1">
                        {translate('customergroups.headline')}
                    </Text>
                    <Button
                        emphasis="high"
                        LeadingIcon={IconPlus}
                        onClick={() => {
                            const drawerId = push({
                                header: { title: translate('customergroup.createtitle') },
                                content: <CreateCustomerGroup onSuccess={() => pop(drawerId)} />,
                            });
                        }}
                    >
                        {translate('customergroups.create')}
                    </Button>
                </Box>

                <CustomerGroupSearch />

                <CustomerGroupsTable />
            </PageGrid>
        </Page>
    );
};
